module.exports = __webpack_public_path__ + "img/svg图.f58b8410.png";